import { ReactComponent as GettingStartedIcon } from '../../../assets/images/icons/getting-started.svg';
import { ReactComponent as MarketingManagerIcon } from '../../../assets/images/icons/growth-engine-blue.svg';
import { ReactComponent as CreateCampaignIcon } from '../../../assets/images/icons/press-kit-blue.svg';
import { ReactComponent as ArtistIcon } from '../../../assets/images/icons/artist-manager-blue.svg';
import { ReactComponent as AudioIcon } from '../../../assets/images/icons/audio-engineer-blue.svg';
import { ReactComponent as AnalystIcon } from '../../../assets/images/icons/data-analyst-blue.svg';
import { ReactComponent as DistributionIcon } from '../../../assets/images/icons/distribution-blue.svg';
import { ReactComponent as ProfessorUIcon } from '../../../assets/images/icons/professoru-blue.svg';
import { ReactComponent as AmplitudeIcon } from '../../../assets/images/icons/amplitude-ai-blue.svg';
import { ReactComponent as MixEngineerIcon } from '../../../assets/images/icons/mixing-icon.svg';
import { ReactComponent as MasteringEngineerIcon } from '../../../assets/images/icons/mastering-icon.svg';
import { ReactComponent as MixEnhancerIcon } from '../../../assets/images/icons/mix-enhancer-icon.svg';
import { ReactComponent as MixAnalystIcon } from '../../../assets/images/icons/mix-analyst-icon.svg';
import { ReactComponent as ResourceIcon } from '../../../assets/images/icons/resource-library.svg';
import {
  BarChart4Icon,
  Calendar1Icon,
  LayoutDashboardIcon,
  LineChartIcon,
  Link2Icon,
  MapIcon,
  MapPin,
  Mic2Icon,
  Music4,
  MusicIcon,
  RadioIcon,
  UserCircle2,
  Users2Icon,
} from "lucide-react";

export const professorULessons = [
  { id: 1, title: "Lesson 1: Getting Started", type: "icon", thumbnail: GettingStartedIcon, url: "" },
  { id: 2, title: "Lesson 2: Dashboard", type: "icon", thumbnail: LayoutDashboardIcon, url: "/dashboard" },
  { id: 3, title: "Lesson 3: Amplitude AI", type: "icon", thumbnail: AmplitudeIcon, url: "/admin/amplitude-ai" },
  { id: 4, title: "Lesson 4: UrStudio", type: "icon", thumbnail: AudioIcon, url: "/admin/urstudio" },
  { id: 4, title: "Lesson 4.1: Mastering Engineer", type: "icon", thumbnail: MasteringEngineerIcon, url: "/admin/urstudio/audio-engineer-demo" },
  { id: 4, title: "Lesson 4.2: Mixing Engineer", type: "icon", thumbnail: MixEngineerIcon, url: "/admin/urstudio/mixing-engineer-demo" },
  { id: 4, title: "Lesson 4.3: Mix Enhancer", type: "icon", thumbnail: MixEnhancerIcon, url: "/admin/urstudio/mix-enhancer" },
  { id: 4, title: "Lesson 4.4: Mix Analyst", type: "icon", thumbnail: MixAnalystIcon, url: "/admin/urstudio/mix-analyst" },
  { id: 5, title: "Lesson 5.1: Distribution Account Setup", type: "icon", thumbnail: DistributionIcon, url: "/distribution/account-setup-demo" },
  { id: 5, title: "Lesson 5.2: Creating & Publishing A Release", type: "icon", thumbnail: DistributionIcon, url: "/distribution/music-release-demo" },
  { id: 8, title: "Lesson 6: Growth Engine", type: "icon", thumbnail: MarketingManagerIcon, url: "/admin/growth-engine" },
  { id: 8, title: "Lesson 6.1: Create Campaign", type: "icon", thumbnail: CreateCampaignIcon, url: "/admin/growth-engine/campaign-demo" },
  { id: 8, title: "Lesson 6.2: Campaign History", type: "icon", thumbnail: MarketingManagerIcon, url: "/admin/growth-engine/campaign-history" },
  { id: 8, title: "Lesson 6.3: Campaign Editor", type: "icon", thumbnail: BarChart4Icon, url: "/admin/growth-engine/campaign-editor-demo" },
  { id: 7, title: "Lesson 7: Artist Manager", type: "icon", thumbnail: ArtistIcon, url: "/admin/artist-manager" },
  { id: 7, title: "Lesson 7.1: Release and Financial Planner", type: "icon", thumbnail: Calendar1Icon, url: "/admin/artist-manager/release-and-financial-planner" },
  { id: 7, title: "Lesson 7.2: Link And Fan Hub", type: "icon", thumbnail: Link2Icon, url: "/admin/artist-manager/link-and-fan-hub" },
  { id: 7, title: "Lesson 7.3: Build Bio Link", type: "icon", thumbnail: UserCircle2, url: "/admin/artist-manager/build-bio-link" },
  { id: 7, title: "Lesson 7.4: Build Music Link", type: "icon", thumbnail: Music4, url: "/admin/artist-manager/build-music-link" },
  { id: 7, title: "Lesson 7.5: Build Tour Link", type: "icon", thumbnail: Mic2Icon, url: "/admin/artist-manager/build-tour-link" },
  { id: 7, title: "Lesson 7.6: Build Pre-Save Page", type: "icon", thumbnail: Users2Icon, url: "/admin/artist-manager/create-pre-save-demo" },
  { id: 7, title: "Lesson 7.7: Link Analytics", type: "icon", thumbnail: LineChartIcon, url: "/admin/artist-manager/link-analytics-demo" },
  { id: 8, title: "Lesson 8: Data Analyst", type: "icon", thumbnail: AnalystIcon, url: "/admin/data-analyst" },
  { id: 8, title: "Lesson 8.1: Data Analyst Catalog", type: "icon", thumbnail: MapIcon, url: "/admin/data-analyst/catalog" },
  { id: 8, title: "Lesson 8.2: Milestones Activities", type: "icon", thumbnail: MapPin, url: "/admin/data-analyst/milestones" },
  { id: 8, title: "Lesson 8.3: Radio Play Activities", type: "icon", thumbnail: RadioIcon, url: "/admin/data-analyst/radioplay" },
  { id: 9, title: "Lesson 9: ProfessorU", type: "icon", thumbnail: ProfessorUIcon, url: "/admin/professor-u" },
  { id: 9, title: "Lesson 9.1: Guide by Module", type: "icon", thumbnail: ProfessorUIcon, url: "/admin/professor-u/lessons?lesson=Guide by Module" },
  { id: 9, title: "Lesson 9.2: Artist Interviews and Talks with Industry Experts", type: "icon", thumbnail: ProfessorUIcon, url: "/admin/professor-u/contents?content=Artist Interviews and Talks with Industry Experts" },
  { id: 9, title: "Lesson 9.3: Module Walkthroughs", type: "icon", thumbnail: ProfessorUIcon, url: "/admin/professor-u/contents?content=Module Walkthroughs" },
  { id: 9, title: "Lesson 9.4: ProfessorU Rewards", type: "icon", thumbnail: MusicIcon, url: "/admin/professor-u/rewards" },
  { id: 9, title: "Lesson 9.5: ProfessorU Resource Library", type: "icon", thumbnail: ResourceIcon, url: "/admin/professor-u/resource-library" },
];

function slugify(value) {
  return value
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export function parseLessonMeta(title) {
  const match = title.match(/^Lesson\s+(\d+)(?:\.(\d+))?:\s*(.*)$/i);
  return {
    moduleNumber: match ? Number(match[1]) : 0,
    subNumber: match?.[2] != null ? Number(match[2]) : null,
    name: match ? match[3] : title,
  };
}

export const GETTING_STARTED_MODULE_ID = "getting-started";
export const GETTING_STARTED_MODULE_TITLE = "Getting Started";

const MODULE_CATEGORY_LABELS = {
  5: "Distribution",
};

const LESSON_NUMBER_TO_MODULE = {
  1: GETTING_STARTED_MODULE_TITLE,
  2: GETTING_STARTED_MODULE_TITLE,
  3: "Amplitude AI",
  4: "UrStudio",
  5: "Distribution",
  6: "Growth Engine",
  7: "Artist Manager",
  8: "Data Analyst",
  9: "ProfessorU",
};

const MODULE_TITLE_ALIASES = {
  "Artsist Manager": "Artist Manager",
  Dashboard: GETTING_STARTED_MODULE_TITLE,
  "Audio Engineer": "UrStudio",
};

export function normalizeModuleTitle(title = "") {
  const trimmed = String(title).trim();
  return MODULE_TITLE_ALIASES[trimmed] || trimmed;
}

function getModuleLabelForLesson(lesson) {
  const meta = parseLessonMeta(lesson.title);
  return LESSON_NUMBER_TO_MODULE[meta.moduleNumber]
    || MODULE_CATEGORY_LABELS[meta.moduleNumber]
    || meta.name;
}

function withModuleLessonNumbers(lessons) {
  return lessons.map((lesson, index) => {
    const name = lesson.name ?? parseLessonMeta(lesson.title).name;
    return {
      ...lesson,
      title: `Lesson ${index + 1}: ${name}`,
    };
  });
}

export function getProfessorULessonsForModule(moduleTitle, lessons = professorULessons) {
  const normalized = normalizeModuleTitle(moduleTitle);
  if (!normalized) return [];

  return withModuleLessonNumbers(
    lessons.filter((lesson) => getModuleLabelForLesson(lesson) === normalized)
  );
}

export function getProfessorUModules(lessons = professorULessons) {
  const groups = new Map();

  lessons.forEach((lesson) => {
    const meta = parseLessonMeta(lesson.title);
    const label = getModuleLabelForLesson(lesson);
    if (!groups.has(label)) {
      groups.set(label, []);
    }
    groups.get(label).push({ ...lesson, ...meta });
  });

  return Array.from(groups.entries()).map(([label, groupTours]) => {
    const tours = withModuleLessonNumbers(groupTours);
    const main = groupTours.find((tour) => tour.subNumber == null) || groupTours[0];
    return {
      id: slugify(label),
      moduleNumber: main.moduleNumber,
      label,
      icon: main.thumbnail,
      count: tours.length,
      tours,
    };
  });
}

export const GETTING_STARTED_TOUR_PATH = "/admin/professor-u";
